import * as React from "react";
const SvgBroom = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 2a.75.75 0 0 0-1.5 0v10.25H10.5A3.75 3.75 0 0 0 6.75 16c0 .764-.14 1.97-.552 3.06-.414 1.098-1.042 1.924-1.92 2.224a.749.749 0 0 0 .24 1.466h3.965a.81.81 0 0 0 .034 0H16.5a.75.75 0 0 0 .237-.039c1.514-.504 2.382-1.842 2.865-3.121.488-1.294.648-2.688.648-3.59a3.75 3.75 0 0 0-3.75-3.75h-2.25V2Zm-.75 11.75h-3a2.25 2.25 0 0 0-2.122 1.5h10.244a2.25 2.25 0 0 0-2.122-1.5h-3Zm-5.13 7.5H6.707a6.629 6.629 0 0 0 .894-1.66c.368-.975.55-2.005.616-2.84h2.495a9.124 9.124 0 0 1-.515 2.31c-.4 1.06-.998 1.866-1.829 2.19Zm4 0h-1.662a6.63 6.63 0 0 0 .894-1.66c.368-.975.55-2.005.616-2.84h2.495a9.124 9.124 0 0 1-.515 2.31c-.4 1.06-.998 1.866-1.829 2.19Zm4 0h-1.662a6.63 6.63 0 0 0 .894-1.66c.368-.975.55-2.005.616-2.84h2.495a9.124 9.124 0 0 1-.515 2.31c-.4 1.06-.998 1.866-1.829 2.19Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgBroom;
